import moment from "moment";

export const DEFAULT_WORKDAY_SECONDS = 8 * 3600;

export function parseTimeCounter(value) {
	if (value === 0 || value == null || value === "") {
		return { hours: "00", minutes: "00", seconds: "00" };
	}

	const str = String(value);
	if (!str.includes(":")) {
		return { hours: "00", minutes: "00", seconds: "00" };
	}

	const [h = "0", m = "0", s = "0"] = str.split(":");
	return {
		hours: String(h).padStart(2, "0"),
		minutes: String(m).padStart(2, "0"),
		seconds: String(s).padStart(2, "0"),
	};
}

export function formatClockinHms(seconds) {
	const safe = Math.max(0, Math.floor(Number(seconds) || 0));
	const hours = Math.floor(safe / 3600);
	const minutes = Math.floor((safe % 3600) / 60);
	const secs = safe % 60;
	return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
}

export function formatGoalElapsed(seconds) {
	const safe = Math.max(0, Math.floor(Number(seconds) || 0));
	const hours = Math.floor(safe / 3600);
	const minutes = Math.floor((safe % 3600) / 60);
	return `${hours}h ${String(minutes).padStart(2, "0")}m`;
}

export function getWorkdayTargetHours(targetSeconds = DEFAULT_WORKDAY_SECONDS) {
	return Math.round((Number(targetSeconds) || DEFAULT_WORKDAY_SECONDS) / 3600);
}

export function getWorkedSecondsIncludingOngoing(times, now = moment()) {
	if (!Array.isArray(times) || times.length === 0) return 0;

	return times.reduce((total, time) => {
		if (!time?.type?.work_time || !time.start) return total;

		const start = moment.utc(time.start);
		const end = time.end ? moment.utc(time.end) : moment.utc(now);
		const seconds = end.diff(start, "seconds");
		return total + (Number.isFinite(seconds) && seconds > 0 ? seconds : 0);
	}, 0);
}

export function getDayProgressPercent(
	workedSeconds,
	targetSeconds = DEFAULT_WORKDAY_SECONDS
) {
	if (!targetSeconds || targetSeconds <= 0) return 0;
	const ratio = (Number(workedSeconds) || 0) / targetSeconds;
	return Math.min(100, Math.max(0, ratio * 100));
}

export function findPauseTimeType(list) {
	if (!list || list.length === 0) return null;
	return list.find((type) => {
		const name = (type?.name || "").toLowerCase().trim();
		return name === "pausa" || name.includes("pausa");
	});
}
